// Shorter than the 15 s Start calls registration wait because an interpreter
// is on a live call while recovery runs.
export const SIP_USER_AGENT_RECOVERY_TIMEOUT_MS = 10_000;
export const SIP_USER_AGENT_RECOVERY_POLL_INTERVAL_MS = 100;
